// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OvWO0","col":"styles_col__W484A","actions":"styles_actions__3dOV8","conflict":"styles_conflict__20EA6"};